import { render, staticRenderFns } from "./BaseTableColumn.vue?vue&type=template&id=3f235482&scoped=true&"
import script from "./BaseTableColumn.vue?vue&type=script&lang=js&"
export * from "./BaseTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f235482",
  null
  
)

export default component.exports